<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<h2 v-show="!trash">Users</h2>
        		<h2 v-show="trash">Users - Trash</h2>
			</b-col>
		</div>
		<div class="card">
			<div class="card-body">
				<b-row>
					<b-container fluid>
						<div class="row">
							<b-row>
							<b-col lg="3" md="6" xs="12" class="my-1">
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<b-form-input v-model="filter" placeholder="Search" />
										<b-btn class="brad-0" :disabled="!filter" @click="filter = ''">Clear</b-btn>
									</div>
								</div>
							</b-col>
							<b-col lg="3" class="my-1">
								<b-dropdown class="pull-left" :text="dpdt">
									<b-dropdown-item @click="trashUser()">Active</b-dropdown-item>
									<b-dropdown-item @click="trashUser()">Trash</b-dropdown-item>
								</b-dropdown>
							</b-col>

							<b-col v-if="role ==='super_admin' || role ==='analyst' || role =='marketing_accountant'" lg="3" class="my-1" title="Trucking Companies" >
                  				<b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.trucking_company_name">
                    				<b-dropdown-item @click="tcFilter('All Trucking Companies', 0)"><h6>All Trucking Companies</h6></b-dropdown-item>
                    				<b-dropdown-item v-for="trucking_company_filter in trucking_companies_filter" @click="tcFilter(trucking_company_filter.name, trucking_company_filter.id)">{{trucking_company_filter.name}}</b-dropdown-item>
                  				</b-dropdown>
              				</b-col>
							<b-col lg="3" md="6" xs="12">
								<b-button @click="showNewUserModal" variant="primary" class="active mb-3 pull-right">Add User</b-button>
							</b-col>
							 </b-row>

						</div>

						<b-row v-if="loadingData">
							<b-col cols="12" sm="12" md="12" lg="12">
								<p class="text-center">
									<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
								</p>
							</b-col>
						</b-row>
						<b-table class="animated fadeIn" v-else striped hover bordered show-empty stacked="md" :items="items" :fields="fieldsTh" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered"
						@row-clicked="rowClicked">
						</b-table>
						<!-- User Interface controls -->
						<b-row>
							<b-col lg="2" md="2" sm="12" class="my-1 pull-left">
								<div class="input-group mb-3">
									<div class="input-group-prepend"> </div>
									<b-select :options="pageOptions" v-model="perPage" />
								</div>
							</b-col>
							<b-col lg="10" md="10" sm="12" class="my-1 pull-right">
								<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
							</b-col>
						</b-row>
					</b-container>
				</b-row>
			</div>
		</div>
		<!-- New User Modal-->
		<b-modal title="New User" ref="newUser" v-model="newUser" size="lg" hide-header-close no-close-on-backdrop no-close-on-esc>
			<b-row>

				<b-col cols="12">
					<p v-if="this.role === 'super_analyst'">You can only create user as Analyst, they will have the same privileges as you except that they can not create, delete nor update other users of type Analyst.</p>
					<b-form-group label="First Name" label-for="FirstName" :label-cols="3" horizontal>
						<b-form-input type="text" v-model="first_name" class="form-control" @keydown.native="isLetter($event)"/>
					</b-form-group>
					<b-form-group label="Last Name" label-for="LastName" :label-cols="3" horizontal>
						<b-form-input type="text" v-model="last_name" class="form-control" @keydown.native="isLetter($event)"/>
					</b-form-group>

					<b-form-group label="Email" label-for="Email" :label-cols="3" horizontal>
						<b-form-input type="email" v-model="email" class="form-control" @keypress.native="isLowerCaseEmail($event)"/>
					</b-form-group>


					<b-form-group v-if="role === 'super_admin' || role === 'operations_manager' || role === 'trucking_company_admin' || role === 'trucking_company_admin_light' || role === 'trucking_operational_manager'" :label-cols="3" id="L4" label="User Role" label-for="RoleID" horizontal>
						<b-form-select text-field="name" value-field="id" id="RoleID" v-model="user_role_id" :options="userrolesselect" @input="select_user_role()" />
					</b-form-group>

					<b-form-group v-if="showPhone" label="Phone Number" label-for="Phone Number" :label-cols="3" horizontal>
						<b-form-input  v-mask="'##########'" v-model="phone" class="form-control" />
					</b-form-group>

					<b-form-group v-if="showExtras"  label="Terminal Boss ID" label-for="terminal_boss_user_id" :label-cols="3" horizontal>
						<b-form-input type="text" v-model="terminal_boss_user_id" class="form-control" />
					</b-form-group>

					<b-form-group v-if="showTC" :label-cols="3" id="L4" label="Trucking Company" label-for="tcID" horizontal>
						<b-form-select text-field="name" value-field="id" id="tcID" v-model="trucking_company_id" :options="truckingcompanyselect" @input="select_trucking_company()" />
					</b-form-group>

					<b-form-group v-if="energycompanyselect.length > 0 && showEC" :label-cols="3" id="L4" label="Energy Companies" label-for="ECID" horizontal>
						<b-form-radio-group text-field="name" value-field="id" class="custom-checkboxes" :options="energycompanyselect" name="radioSubComponent" plain v-model="energy_company_id" @input="select_energy_company()"></b-form-radio-group>
					</b-form-group>

					<b-form-group v-if="operatingareasselect.length > 0 && showExtras" :label-cols="3" id="L4" label="Operating Areas" label-for="OAID" horizontal>
						<b-form-checkbox-group  text-field="name" value-field="id" class="custom-checkboxes" :options="operatingareasselect" name="Checkboxes" plain v-model="operating_areas_id" @input="operatingAreaChange"></b-form-checkbox-group>
						<b-form-checkbox style="margin-top: 15px;" v-model="oaAllSelected" :indeterminate="indeterminateOA" aria-describedby="" aria-controls="" plain @change="oaToggleAll">
							{{ oaAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>

					<b-form-group v-if="loadlocationsselect.length > 0 && showExtras" :label-cols="3" id="L4" label="Assigned Load Locations" label-for="LLID" horizontal>
						<b-form-checkbox-group text-field="name" value-field="id" class="custom-checkboxes" :options="loadlocationsselect" name="Checkboxes" plain disabled v-model="load_locations_id" ></b-form-checkbox-group>
		<!--				<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="llToggleAll"> @input="llChange"
							{{ llAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox> -->
					</b-form-group>
					<b-form-group v-if="unloadlocationsselect.length > 0 && showExtras" :label-cols="3" id="L4" label="Assigned Unload Locations" label-for="ULID" horizontal>
						<b-form-checkbox-group text-field="name" value-field="id" class="custom-checkboxes" :options="unloadlocationsselect" name="Checkboxes" plain disabled v-model="unload_locations_id" ></b-form-checkbox-group>
			<!--			<b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ulToggleAll">@input="ulChange"
							{{ ulAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox> -->
					</b-form-group>
					<b-form-group v-if="role !== 'operations_manager' && (current_user_role_name === 'analyst'|| this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant')" :label-cols="4" id="L17" label="All Operating Areas Access?" label-for="ULID" horizontal>
										<b-form-checkbox 
                  		id="checkbox"
											class="custom-checkboxes"
                  		v-model="operating_areas_access" 
											style="margin-top: 13px;"
                		></b-form-checkbox>	
					</b-form-group>	
					<b-form-group v-if="role !== 'operations_manager' && (current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') && !operating_areas_access" :label-cols="3" id="L4" label="Operating Areas" label-for="OAID" horizontal>
									<b-form-checkbox-group v-if="operatingareasselect.length > 0" text-field="name" value-field="id" class="custom-checkboxes" :options="operatingareasselect" name="Checkboxes" plain v-model="operating_areas_id" @input="operatingAreaChange"></b-form-checkbox-group>
					</b-form-group>	
					<!-- Favoritos   -->	
					<b-form-group v-if="favorites_load.length > 0 && showExtras" :label-cols="3" id="L4" label="Favorite Load Locations" label-for="ULID" horizontal>
						<b-form-checkbox-group text-field="name" value-field="id" class="custom-checkboxes" :options="favorites_load" name="Checkboxes" plain v-model="favorites_load_id" @input="llChange"></b-form-checkbox-group>
			  			<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="llToggleAll">
							{{ llAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>	
					<b-form-group v-if="favorites_unload.length > 0 && showExtras" :label-cols="3" id="L4" label="Favorite Unload Locations" label-for="ULID" horizontal>
						<b-form-checkbox-group text-field="name" value-field="id" class="custom-checkboxes" :options="favorites_unload" name="Checkboxes" plain v-model="favorites_unload_id" @input="ulChange"></b-form-checkbox-group>
			  			<b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ulToggleAll">
							{{ ulAllSelected ? 'Un-select All' : 'Select All' }}
						</b-form-checkbox>
					</b-form-group>
					<!-- End Favorites  -->
				</b-col>
			</b-row>
			<div slot="modal-footer" class="w-100">
				<b-btn size="md" variant="secondary" @click="newUser=false" class="float-left">Cancel</b-btn>
				<b-btn :disabled="savebtn" size="md" variant="primary" @click="saveUser" class="float-right">Save</b-btn>
			</div>
		</b-modal>
		<!-- End New User Modal-->
		<!-- Table Config-->
		<b-modal title="Config Table" v-model="configTable" ok-variant="primary">
			<b-row>
				<b-col cols="12">
					<b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
						<b-form-checkbox value="id" :disabled="true" @change="actionField('id')">User ID</b-form-checkbox>
						<b-form-checkbox value="first_name" @change="actionField('first_name')">First Name</b-form-checkbox>
						<b-form-checkbox value="last_name" @change="actionField('last_name')">Last Name</b-form-checkbox>
						<b-form-checkbox value="username" :disabled="true" @change="actionField('username')">Username</b-form-checkbox>
						<b-form-checkbox value="email" @change="actionField('email')">Email</b-form-checkbox>
						<b-form-checkbox value="role" @change="actionField('role')">Role</b-form-checkbox>
						<b-form-checkbox value="status" @change="actionField('status')">Status</b-form-checkbox>
					</b-form-checkbox-group>
				</b-col>
			</b-row>
		</b-modal>
		<!-- Table Config-->
	</div>
</template>

<style>
	.table tbody tr:hover {
		background-color: rgb(222, 225, 229);
		color: #030303;
		cursor: pointer;
	}

	table div {
		padding: 0.45rem;
	}

	.table td {
		padding: 0 !important;
	}
</style>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
	import users_service from './users_service'
	import roles_service from '../roles/roles_service'
	import haul_service from '../hauls/haul_service'
	const items = []
	const fields = [{
			key: 'username',
			label: 'User Name',
			sortable: true
		},
		{
			key: 'email',
			label: 'Email',
			sortable: true
		},
		{
			key: 'first_name',
			label: 'First Name'
		},
		{
			key: 'last_name',
			label: 'Last Name'
		},
		{
			key: 'role',
			label: 'Role'
		},
		{
			key: 'status',
			label: 'Status',
			sortable: true
		}
	]
	export default {
		name: 'users',
		created: function() {
			//localStorage.setItem('filter', 'All Trucking Companies')
			//if (localStorage.getItem("role") == "super_admin" || localStorage.getItem("role") == "super_analyst" || localStorage.getItem("role") == "analyst") {
				//this.getFilters()
    	//}
			this.getAll()
			localStorage.removeItem("ftPage");
			localStorage.removeItem("targetsaPage");
			localStorage.removeItem("tpPage");
			localStorage.removeItem("oasaPage");
			localStorage.removeItem("oaPage");
			localStorage.removeItem("reportPage");
			localStorage.removeItem("rolesPage");
			localStorage.removeItem("servicePage");
			localStorage.removeItem("taPage");
			localStorage.removeItem("tasaPage");
			localStorage.removeItem("locationPage");
			localStorage.removeItem("truckPage");
			localStorage.removeItem("tcPage");
			if (!localStorage.userPage) {
					localStorage.userPage = 0;
			}
		},
		data() {
			return {
				trash: false,
				dpdt: 'Active',
				roleSuperAnalyst: '',
				EnergyCompanySA: '',
				isSuperAnalyst: false,
				indeterminateOA: false,
				oaAllSelected: false,
				roleBySuperAnalyst: '',
				indeterminateLL: false,
				llAllSelected: false,
				indeterminateUL: false,
				ulAllSelected: false,

				current_user_role_name: '',
				insert_data: null,
				userrolesselect: [],
				energycompanyselect: [],
				truckingcompanyselect: [],
				loadlocationsselect: [],
				unloadlocationsselect: [],
				operatingareasselect: [],

				user_role_id: '',
				phone: '',
				energy_company_id: '',
				operating_areas_id: [],
				trucking_company_id: '',
				load_locations_id: [],
				unload_locations_id: [],
				first_name: '',
				last_name: '',
				email: '',
				terminal_boss_user_id :'',

				showTC: false,
				showPhone: false,
				showEC: false,
				showExtras: false,

				items: items,
				itemsO: items,
				loadingData: true,
				currentPage: parseInt(localStorage.userPage),
				newUser: false,
				perPage: 25,
				totalRows: items.length,
				pageOptions: [25, 50, 100],
				sortBy: 'id',
				sortDesc: true,
				fields: fields,
				fieldsTh: [
					{
						key: 'id',
						label: 'ID',
						sortable: true
					},
					{
						key: 'first_name',
						label: 'First Name'
					},
					{
						key: 'last_name',
						label: 'Last Name'
					},
					{
						key: 'username',
						label: 'Username',
						sortable: true
					},
					{
						key: 'email',
						label: 'Email',
						sortable: true
					},
					{
						key: 'phone',
						label: 'Phone'
					},
					{
						key: 'role',
						label: 'Role'
					},
					//{ key: 'actions', label: 'Actions' }
				],
				filter: null,
				modalInfo: {
					title: '',
					content: ''
				},
				configTable: false,
				selectedItems: ['id', 'username', 'email', 'first_name', 'last_name', 'role'],
				role:'',
				view:true,
				savebtn:true,
				trucking_company_iidd :null,
				text : 'Trucking Company',
				trucking_companies_filter : [],
				filters_save: {
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          users_id                : 0,
          driver_name             : 'All Drivers',
          truck_id                : 0,
          truck_name              : 'All Trucks',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          fluid_type_id           : 0,
          fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All UnLoads',
          initial_date            : '',
          end_date                : '',
          flag_name               : 'All Flags',
          sortby                  : 'haul_id',
          sortdesc                : false,
        },
        filters_start: {
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          users_id                : 0,
          driver_name             : 'All Drivers',
          truck_id                : 0,
          truck_name              : 'All Trucks',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          fluid_type_id           : 0,
          fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All UnLoads',
          initial_date            : '',
          end_date                : '',
          flag_name               : 'All Flags',
          sortby                  : 'haul_id',
          sortdesc                : false
				},
				filter_by:{"initial_date": moment().startOf('month').format('YYYY-MM-DD'), "end_date": moment().endOf('month').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "", "folder_id":"", "fluid_type_id":"","flags":"",
        "column":[
          'haul_id',
          'load_location',
          'unload_location',
          'volume_actual',
          'oil_actual',
          'water_actual',
          'bsw',
          'haul_start_date',
          'haul_start_time',
        ]},
				operating_areas_access		: true,
				favorites_load_id    			: [],
				favorites_unload_id 			: [],
				favorites_load						:	[],
				favorites_unload					:	[],
			}
		},
		computed: {
			sortOptions() {

				// Create an options list from our fields
				return this.fieldsTh
					.filter(f => f.sortable)
					.map(f => {
						return {
							text: f.label,
							value: f.key
						}
					})
			}
		},
		methods: {
      activate_custom_backdrop() {
        this.$root.$el.classList.add("custom_backdrop_behavior");
      },
      deactivate_custom_backdrop() {
        this.$root.$el.classList.remove("custom_backdrop_behavior");
	  	},
	    tcFilter(tc_filter,id) {
        this.filters_save.trucking_company_name =  tc_filter
				this.filters_save.trucking_company_id = id
				if (tc_filter==='All Trucking Companies') {
					this.items = this.itemsO
				} else {
					let result = this.itemsO.filter(item => {return item.trucking_company==tc_filter});
					this.items = result
				}
				//this.saveFilters()
        //this.loadingData = true
      },
			rowClicked(row) {
				 localStorage.userPage = this.currentPage;
				if (!this.trash) {
					this.$router.push('/user/' + row.id + '/')
				} else {
					this.restoreUser(row.id)
				}
			},
			llChange(value) {
					if (this.favorites_load_id.length === 0) {
						this.indeterminateLL = false
						this.llAllSelected = false
					} else if (this.favorites_load_id.length === this.favorites_load.length) {
						this.indeterminateLL = false
						this.llAllSelected = true
					} else {
						this.indeterminateLL = true
						this.llAllSelected = false
					}
			},
			ulChange(value) {
					if (this.favorites_unload_id.length === 0) {
						this.indeterminateUL = false
						this.ulAllSelected = false
					} else if (this.favorites_unload_id.length === this.favorites_unload.length) {
						this.indeterminateUL = false
						this.ulAllSelected = true
					} else {
						this.indeterminateUL = true
						this.ulAllSelected = false
					}
			},
			operatingAreaChange() {
					// Additional
					let operating_area   	= this.operatingareasselect
					let operating_area_id   = this.operating_areas_id
					if (operating_area_id === true) {
						return
					}
					let ll = operating_area_id.map(item => {
						let oa_index = operating_area.map(o => o.id).indexOf(item)
						if (oa_index > -1) {
							return operating_area[oa_index].load_locations.map(o => o.id)
						}
					})

					let ul = operating_area_id.map(item => {
						let oa_index = operating_area.map(o => o.id).indexOf(item)
						if (oa_index > -1) {
							return operating_area[oa_index].unload_locations.map(o => o.id)
						}
					})
					this.load_locations_id = Array.prototype.concat.apply([], ll)
					this.unload_locations_id = Array.prototype.concat.apply([], ul)
					// favorites
					// load 
					let l_locations   		= this.loadlocationsselect
					let l_locations_id   = 	this.load_locations_id				
					let oa_ll = l_locations_id.map(item => {
						let oa_index = l_locations.map(o => o.id).indexOf(item)
						if (oa_index > -1) {
							return l_locations[oa_index]
						}
					})
					this.favorites_load = this.arrayUnique(oa_ll)
					this.favorites_load_id = []
					// unload
					let ul_locations   		= this.unloadlocationsselect
					let ul_locations_id   = this.unload_locations_id				
					let oa_ul = ul_locations_id.map(item => {
						let oa_index = ul_locations.map(o => o.id).indexOf(item)
						if (oa_index > -1) {
							return ul_locations[oa_index]
						}
					})
					this.favorites_unload = this.arrayUnique(oa_ul)
					this.favorites_unload_id = []
					// End
					if (this.current_user_role_name === 'driver') {
						if (this.operating_areas_id.length === 0) {
							this.indeterminateOA = false
							this.oaAllSelected = false

						} else if (this.operating_areas_id.length === this.operatingareasselect.length) {
							this.indeterminateOA = false
							this.oaAllSelected = true

						} else {
							this.indeterminateOA = true
							this.oaAllSelected = false
						}
					}


			},
			oaToggleAll(checked) {
				this.operating_areas_id = checked ? this.operatingareasselect.map(item => {
					return item.id
					}) : []
			},
			llToggleAll(checked) {
				this.favorites_load_id = checked ? this.favorites_load.map(item => {
					return item.id
					}) : []
			},
			ulToggleAll(checked) {
				this.favorites_unload_id = checked ? this.favorites_unload.map(item => {
					return item.id
					}) : []
			},
			select_trucking_company() {

				let current_user_role_index = this.insert_data.roles.map(o => o.id).indexOf(this.user_role_id)			
				if (current_user_role_index > -1) {
					let current_user_role_name = this.insert_data.roles[current_user_role_index].name.toLowerCase()
					if (current_user_role_name === 'driver') {					
						let current_trucking_company_index = this.insert_data.roles[current_user_role_index].trucking_companies.map(o => o.id).indexOf(this.trucking_company_id)
						if (current_trucking_company_index > -1) {
							let truckingcompany = this.insert_data.roles[current_user_role_index].trucking_companies[current_trucking_company_index]
							this.energycompanyselect = [] //truckingcompany.energy_companies
							this.operatingareasselect 	= truckingcompany.operating_areas
							this.loadlocationsselect  	= truckingcompany.load_locations
							this.unloadlocationsselect  = truckingcompany.unload_locations
							this.operating_areas_id 		= []
							this.unload_locations_id 		= []
							this.load_locations_id 			= []
							// Favorites
							this.favorites_load_id    		= []
							this.favorites_unload_id 			= []
							this.favorites_load						=	[]
							this.favorites_unload					=	[]							

							this.indeterminateOA = false
							this.oaAllSelected = false
							this.indeterminateLL = false
							this.llAllSelected = false
							this.indeterminateUL = false
							this.ulAllSelected = false
						}
					}
				}
			},
			select_energy_company() {
				if (this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') {
						this.operating_areas_id = []
						this.checkbox_oa = true
						let current_user_role_index = this.insert_data.roles.map(o => o.id).indexOf(this.user_role_id)
						if (current_user_role_index > -1) {
							let energycompanies = this.insert_data.roles[current_user_role_index].energy_companies
							let ec_index = energycompanies.map(o => o.id).indexOf(this.energy_company_id)
							if (ec_index > -1) {
								this.operatingareasselect = energycompanies[ec_index].operating_areas
							}	 
						}
				}
			},
			select_user_role() {
			if (this.role =='super_admin') {
				let current_user_role_index = this.insert_data.roles.map(o => o.id).indexOf(this.user_role_id)
				if (current_user_role_index > -1) {
					this.current_user_role_name = this.insert_data.roles[current_user_role_index].name.toLowerCase()
					if (this.current_user_role_name === 'operations_manager') {
						let energycompanies = this.insert_data.roles[current_user_role_index].energy_companies
						this.energycompanyselect = Array.isArray(energycompanies) ? [...energycompanies] : []
						this.showEC = true
						this.showTC = false
						this.showExtras = false
						this.energy_company_id = ''
						this.indeterminateEC = false
						this.ecAllSelected = false
						this.showPhone = false
						this.operatingareasselect 	= []
						this.operating_areas_access		= true
					} else if (this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') {
						let energycompanies = this.insert_data.roles[current_user_role_index].energy_companies
						this.energycompanyselect = Array.isArray(energycompanies) ? [...energycompanies] : []
						this.showEC = true
						this.showTC = false
						this.showExtras = false
						this.energy_company_id = ''
						this.indeterminateEC = false
						this.ecAllSelected = false
						this.showPhone = false
						this.operatingareasselect 	= []
						this.operating_areas_access		= true
					} else if (this.current_user_role_name === 'driver' || this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.current_user_role_name === 'trucking_operational_manager') {
						let truckingcompanies = this.insert_data.roles[current_user_role_index].trucking_companies
						this.truckingcompanyselect = Array.isArray(truckingcompanies) ? [...truckingcompanies] : []
						this.showTC = true
						this.showEC = false
						this.showPhone = false
						this.trucking_company_id = ''
						// Modified by Carlos Rondon 21/02/2019 trucking company
						this.operatingareasselect 	= []
						this.loadlocationsselect  	= []
						this.unloadlocationsselect  = []
						// end Added
						if (this.current_user_role_name === 'driver') {
										this.showExtras = true
										this.showPhone = true
										this.loadlocationsselect = []
										this.unloadlocationsselect = []
										this.load_locations_id = []
										this.unload_locations_id = []
										// Favorites
										this.favorites_load_id    		= []
										this.favorites_unload_id 			= []
										this.favorites_load						=	[]
										this.favorites_unload					=	[]	

										this.indeterminateOA = false
										this.oaAllSelected = false
										this.indeterminateLL = false
										this.llAllSelected = false
										this.indeterminateUL = false
										this.ulAllSelected = false
						} else {
							this.showPhone = false
							this.showExtras = false
						}
					} else {
						this.showEC = false
						this.showPhone = false
						this.showTC = false
						this.showExtras = false
					}

				}
			} else if (this.role =='trucking_company_admin' || this.role === 'trucking_operational_manager'){
					this.showExtras = false
					this.showPhone = false
					this.select_trucking_company_admin()
			} else if (this.role =='operations_manager'){
				//Get the user role name
				let current_user_role_index = this.insert_data.roles.map(o => o.id).indexOf(this.user_role_id)
				if (current_user_role_index > -1) {
					this.current_user_role_name = this.insert_data.roles[current_user_role_index].name.toLowerCase()
					if (this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'marketing_accountant') {
						let energycompanies = this.insert_data.roles[current_user_role_index].energy_companies
						this.energycompanyselect = Array.isArray(energycompanies) ? [...energycompanies] : []
						this.showEC = false
						this.showTC = false
						this.showExtras = false
						//this.energy_company_id = ''
						this.indeterminateEC = false
						this.ecAllSelected = false
						this.showPhone = false
						this.operatingareasselect 	= []
						this.operating_areas_access		= true
					} else if (this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || role === 'trucking_operational_manager') {
						let truckingcompanies = this.insert_data.roles[current_user_role_index].trucking_companies
						this.truckingcompanyselect = Array.isArray(truckingcompanies) ? [...truckingcompanies] : []
						this.showTC 						= true
						this.showEC 						= false
						this.showPhone 					= false
						this.trucking_company_id = ''
						// Modified by Carlos Rondon 21/02/2019 trucking company
						this.operatingareasselect 	= []
						this.loadlocationsselect  	= []
						this.unloadlocationsselect  = []
						// end Added
					
					} else {
						this.showEC = false
						this.showPhone = false
						this.showTC = false
						this.showExtras = false
					}

				}
			}
			},
			showNewUserModal() {
				this.user_role_id 					= ''
				this.current_user_role_name = ''
				this.phone 									= ''
				this.savebtn								=false
				if (this.role !=='operations_manager' ) {
					this.energy_company_id 			= ''
				}			
				this.operating_areas_id 		= []
				this.trucking_company_id 		= ''
				this.load_locations_id 			= []
				this.unload_locations_id 		= []
				// Favorites
				this.favorites_load_id    		= []
				this.favorites_unload_id 			= []
				this.favorites_load						=	[]
				this.favorites_unload					=	[]	

				this.first_name 						= ''
				this.last_name 							= ''
				this.email 									= ''
				this.terminal_boss_user_id 	= ''
				this.showTC 								= false
				this.showEC 								= false
				if (this.role =='trucking_company_admin' || this.role === 'trucking_operational_manager') {
					this.showExtras = false
				} 
				if (this.role =='trucking_company_admin_light' ) {
					this.showExtras = true
				} else {
					this.showExtras = false
				}
				this.newUser 								= true
				
			},
			actionField(option) {
				var fieldsThLength = this.fieldsTh.length
				var fieldIsActive = false
				for (var i = 0; i <= fieldsThLength; i++) {
					fieldIsActive = true
					try {
						if (this.fieldsTh[i].key === option || this.fieldsTh[i] === option) {
							this.fieldsTh.splice(i, 1)
							fieldIsActive = false
							break
						}
					} catch (err) {
						//var position = this.fields.indexOf(option)
						//this.fieldsTh.splice(position,0,option)
						var length_fields = fields.length
						var position = -1
						for (var i = 0; i < length_fields; i++) {
							position = i
							if (fields[i].key == option) {
								this.fieldsTh.splice(position, 0, fields[position])
								break
							}
						}
					}
				}
			},
			onFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.totalRows = filteredItems.length
				 this.currentPage = parseInt(localStorage.userPage)
			},
			trashUser() {
				this.trash = !this.trash
				this.dpdt = this.trash ? "Trash" : "Active"
				this.getAll()
				this.loadingData = true
			},
			restoreUser(id) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to restore this User?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						users_service.restore(id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.filter = ''
									this.trash = false
									this.getAll()
									this.loadingData = true
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			getAll() {
				this.loadingData = true
				users_service.getAll()
					.then(data => {
						if (data[0] == 'success') {
							this.items = data[1].filter(o => o.status_id == (this.trash ? 2 : 1)).map(o => {
								o.role = o.role.trim().replace(/_/g, " ").split(" ").map(function(item) {
									return item.charAt(0).toUpperCase() + item.slice(1)
								}).join(" ")
								return o
							})

							this.itemsO=this.items
							this.trucking_company_iidd 	= data[2]
							this.getAll1()

						} else {
								this.items = []
								this.itemsO=this.items
								this.$swal(data[0], data[1], data[0])
						}
						this.loadingData = false
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			getAll1() {
				users_service.getAll1()
					.then(data => {
						if (data[0] == 'success') {

							this.trucking_companies_filter	=	data[1]
							this.role = data[2]
							this.current_user_role_name == this.role 
						
							this.insert_data = data[3]
							this.userrolesselect = this.insert_data.roles.map(item => {
								return {
									id: item.id,
									name: item.name.trim().replace(/_/g, " ").split(" ").map(function(item) {
										return item.charAt(0).toUpperCase() + item.slice(1)
									}).join(" ")
								}
							})
							
							if (this.role =='super_analyst') {
									this.roleBySuperAnalyst = this.userrolesselect[0].name
									this.user_role_id 			= this.userrolesselect[0].id
									this.energy_company_id 	= this.insert_data.roles[0].energy_companies[0].id
									this.EnergyCompanySA 		= this.insert_data.roles[0].energy_companies[0].name
							} else if (this.role =='trucking_company_admin' || this.role =='trucking_company_admin_light' || this.role === 'trucking_operational_manager') {
									//this.trucking_company_iidd 	= data[2]
									this.trucking_company_id 		= this.trucking_company_iidd
									this.user_role_id 					= this.userrolesselect[0].id
									this.showPhone							=	true
									this.select_trucking_company()

							} else if (this.role =='operations_manager') {
									this.energy_company_id 	= this.trucking_company_iidd //this.insert_data.roles[2].energy_companies[0].id
							} 

						} else {
								this.$swal(data[0], data[1], data[0])
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
			}, 
			okToSave() {
				if (this.role =='super_admin') {
					if (this.user_role_id === undefined || this.user_role_id.length == 0) {
						this.$swal('Alert!', 'User Role not selected', 'warning')
						return false
					}
				}
 				if (this.first_name === null || String(this.first_name).trim().length == 0) {
					this.$swal('Alert!', 'First Name can not be empty', 'warning')
					return false
				} else if (this.last_name === null || String(this.last_name).trim().length == 0) {
					this.$swal('Alert!', 'Last Name can not be empty', 'warning')
					return false
				}
				if(this.current_user_role_name === 'operations_manager' || this.current_user_role_name === 'marketing_accountant' || this.current_user_role_name === 'analyst' || this.current_user_role_name === 'super_analyst') {
					if (this.energy_company_id === undefined || this.energy_company_id.length == 0) {
						this.$swal('Alert!', 'Energy Company not selected', 'warning')
						return false
					}
				} else if(this.current_user_role_name === 'driver' || this.current_user_role_name === 'trucking_company_admin' || this.current_user_role_name === 'trucking_company_admin_light' || this.role === 'trucking_operational_manager') {
					if (this.trucking_company_id === undefined || this.trucking_company_id.length == 0) {
						this.$swal('Alert!', 'Trucking Company not selected', 'warning')
						return false
					}
				}

				return true
			},
			saveUser() {
				if (!this.okToSave()) {
					return
				}
				this.savebtn=true
				let dataUser = {
						email			: this.email,
						last_name	: this.last_name,
						first_name: this.first_name,
						role_id		: this.user_role_id,
						phone			: '',
				}
				if(this.current_user_role_name === 'super_admin') {
					dataUser = {
						...dataUser,
						trucking_company_id: this.trucking_company_id,
						phone			:''
					}
				} else if(this.current_user_role_name === 'super_analyst' || this.current_user_role_name === 'analyst'|| this.current_user_role_name === 'marketing_accountant') {
					dataUser = {
						...dataUser,
						energy_company_id		: this.energy_company_id,
						phone								:'',
						load_locations			:  this.load_locations_id,
						unload_locations		: this.unload_locations_id,
						operating_areas_all : this.operating_areas_access,
						operating_areas  		: this.operating_areas_id,
					}
				} else if(this.current_user_role_name === 'operations_manager') {
					dataUser = {
						...dataUser,
						energy_company_id		: this.energy_company_id,
						phone								:'',
						// load_locations			: this.load_locations_id,
						// unload_locations		: this.unload_locations_id,
						operating_areas_all : this.operating_areas_access,
						// operating_areas  		: this.operating_areas_id,
				}
				} else if(this.current_user_role_name === 'driver') {

					dataUser = {
						...dataUser,
						trucking_company_id: this.trucking_company_id,
						phone:this.phone,
						operating_areas  		: this.operating_areas_id.map(item => {
							return {
								id: String(item)
							}
						}),
						load_locations:  this.favorites_load_id.map(item => {
							return {
								id: String(item)
							}
						}),
						unload_locations: this.favorites_unload_id.map(item => {
							return {
								id: String(item)
							}
						}),
						terminal_boss_user_id : this.terminal_boss_user_id
					}
				} else if(this.current_user_role_name  === 'trucking_company_admin' || this.current_user_role_name  === 'trucking_company_admin_light' || this.current_user_role_name  === 'trucking_operational_manager') {
					dataUser = {
						...dataUser,
						trucking_company_id: this.trucking_company_id,
						phone:'',
					}
				}  else if(this.role  === 'trucking_company_admin_light') {
					dataUser = {
						...dataUser,
						trucking_company_id: this.trucking_company_iidd,
						phone:this.phone,
						operating_areas  		: this.operating_areas_id.map(item => {
							return {
								id: String(item)
							}
						}),
						///load_locations:  this.load_locations_id.map(item => {
						///	return {
						//		id: String(item)
						//	}
						//}),
						//unload_locations: this.unload_locations_id.map(item => {
						//	return {
						//		id: String(item)
						//	}
						//})
					}
					dataUser.role_id=2

				} 
				users_service.save(dataUser)
					.then(data => {
					//	this.$swal(data[0], data[1], data[0])
					//		.then((result) => {
								if (data[0] == 'success') {
									this.newUser = false
									this.getAll()
								} else if (data[0] == 'foundit') {
										
										this.$swal({
												title: 'Please, confirm',
												text: this.first_name+ " " + this.last_name + " is assigned for a different trucking company, would you want to reassign the driver to your company?",
												type: 'question',
												showCancelButton: true,
												confirmButtonColor: '#3085d6',
												cancelButtonColor: '#d33',
												confirmButtonText: 'Yes',
												reverseButtons: true
												}).then((result) => {
														if (result.value) {
																let dataU = {	trucking_company_id: this.trucking_company_iidd,
																							operating_areas  		: this.operating_areas_id.map(item => {
																								return {
																									id: String(item)
																								}})
																							//load_locations:  this.load_locations_id.map(item => {
																							//		return {id: String(item)}}),
																							//unload_locations: this.unload_locations_id.map(item => {
																							//		return { id: String(item)}})
																						}
																let new_user_tc = data[1] 
																users_service.pre_edit(data[1],dataU )
																	.then(data => {
																		if (data[0] == 'success') {
																			 this.newUser=false
																			 this.$router.push('/user/' + new_user_tc + '/')
																		} else {
																			 Vue.swal(data[0], data[1], data[0])
																			 this.newUser=false
																		}
																	})
														} 
											})
								} else {
									 Vue.swal(data[0], data[1], data[0])
								}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.savebtn=false
			},
			isLetter: function(evt) {
        		evt = (evt) ? evt : window.event;
        		var charCode = (evt.which) ? evt.which : evt.keyCode;
				var tecla = String.fromCharCode(charCode).toString();
				var letras = "ABCDEFGHIJKLMNÑOPQRSTUVWXYZ"
				 if(letras.indexOf(tecla) == -1){
					if ((charCode == 8) ||  (charCode == 9)) {
						return true
					} else {
						evt.preventDefault();
          			}
				 } else {
					return true
				 }
      		},
			isLowerCaseEmail: function(evt) {
				evt = (evt) ? evt : window.event;
        		var charCode = (evt.which) ? evt.which : evt.keyCode;
				if ((charCode >= 48 && charCode <= 57) || (charCode >= 97 && charCode <= 122)) {
					return true
				} else {
					if ((charCode == 45) || (charCode == 46) || (charCode == 64) || (charCode == 95) || (charCode == 8) ||  (charCode == 9)) {
						return true
					} else {
						evt.preventDefault();
          			}
				}
      		},
      saveFilters() {
        haul_service.saveFilters(2,this.filters_save)
          .then((data) => {
                if (data[0] == 'success') {
                    return
                } else {
                    Vue.swal(data[0], data[1], data[0])
                    return
                }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            return
          })
    },
    getFilters() {
        haul_service.getFilters(2)
          .then((data) => {
                if (data[0] == 'success') {
                    this.filters_start  = data[1]
                    this.filters_start1 = data[2]
                    if (this.filters_start.length != 0) {
                      // Code Changed and Optimized
                      for (var property in this.filters_start[0]) {
                        this.filters_save[property]   = this.filters_start[0][property]
                        if (this.filters_start[0][property] == 0){
                            this.filter_by[property] = ""
                        } else if (this.filters_start[0][property] == null){
                            this.filter_by[property] = ""
                        } else {
                              this.filter_by[property] = this.filters_start[0][property]
                        }
                      } // for
                      if(this.filters_start[0]['initial_date'] == null)
                      {
                          this.filter_by['initial_date'] = moment().startOf('month').format('YYYY-MM-DD')
                          this.filters_save['initial_date'] = moment().startOf('month').format('YYYY-MM-DD')
                      }
                      if(this.filters_start[0]['end_date'] == null)
                      {
                        this.filter_by['end_date'] = moment().endOf('month').format('YYYY-MM-DD')
                        this.filters_save['end_date'] = moment().endOf('month').format('YYYY-MM-DD')
                      }

                      for (var property in this.filters_start1[0]) {
                        this.filters_save[property]   = this.filters_start1[0][property]
                      } // for

                      if (this.filters_start[0].folder_id == 0 && this.filters_start1[0].folder == 'Unassigned Hauls') {
                        this.filter_by.folder_id = this.filters_start[0].folder_id
                      }
                      this.filters_save.folder_id             = this.filters_start[0].folder_id
                      this.filters_save.folder                = this.filters_start1[0].folder

                    } else {
                        this.filters_save.folder_id             = 0
                        this.filters_save.folder                = "All Folders"
                        this.filters_save.energy_companies_id   = 0
                        this.filters_save.energy_company_name   = "All Energy Companies"
                        this.filters_save.fluid_type_id         = 0
                        this.filters_save.fluid_type_name       = "All Fluid Types"
                        this.filters_save.users_id              = 0
                        this.filters_save.driver_name           = "All Drivers"
                        this.filters_save.truck_id              = 0
                        this.filters_save.truck_name            = "All Trucks"
                        this.filters_save.trucking_company_id   = 0
                        this.filters_save.trucking_company_name = "All Trucking Companies"
                        this.filters_save.unload_location_id    = 0
                        this.filters_save.load_name             = "All Loads"
                        this.filters_save.unload_location_id    = 0
                        this.filters_save.unload_name           = "All Unloads"
                        this.filters_save.flag_name             = "All Flags"
                        this.filters_save.initial_date          = moment().startOf('month').format('YYYY-MM-DD')
                        this.filters_save.end_date              = moment().endOf('month').format('YYYY-MM-DD')
                        this.filters_save.sortby                = 'haul_id'
                        this.filters_save.sortdesc              = false
                        this.filter_by={"initial_date": moment().startOf('month').format('YYYY-MM-DD'), "end_date": moment().endOf('month').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "","folder_id":"","fluid_type_id":"","flags":"",
        									"column":[
          										'haul_id',
          										'load_location',
          										'unload_location',
          										'volume_actual',
          										'oil_actual',
          										'water_actual',
          										'bsw',
          										'haul_start_date',
          										'haul_start_time',
													]}
										}
										localStorage.setItem('filter', this.filters_save.trucking_company_name)
										this.loadingData = true
										return
                } else {
                    Vue.swal(data[0], data[1], data[0])
										this.loadingData = false
										return
                }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
						return
          })
		},
		select_trucking_company_admin() {

				let current_user_role_index = this.insert_data.roles.map(o => o.id).indexOf(this.user_role_id)				
				if (current_user_role_index > -1) {
					let current_user_role_name = this.insert_data.roles[current_user_role_index].name.toLowerCase()	
					this.current_user_role_name = current_user_role_name 
					if (current_user_role_name === 'driver') {				
						let current_trucking_company_index = this.insert_data.roles[current_user_role_index].trucking_companies.map(o => o.id).indexOf(this.trucking_company_iidd)
						if (current_trucking_company_index > -1) {
							let truckingcompany = this.insert_data.roles[current_user_role_index].trucking_companies[current_trucking_company_index]
							this.energycompanyselect 		= []   //truckingcompany.energy_companies
							this.operatingareasselect 	= truckingcompany.operating_areas
							this.loadlocationsselect  	= truckingcompany.load_locations
							this.unloadlocationsselect  = truckingcompany.unload_locations
							this.operating_areas_id 	= []
							this.unload_locations_id 	= []
							this.load_locations_id 		= []
							// Favorites
							this.favorites_load_id    		= []
							this.favorites_unload_id 			= []
							this.favorites_load						=	[]
							this.favorites_unload					=	[]	

							this.indeterminateOA 	= false
							this.oaAllSelected 		= false
							this.indeterminateLL 	= false
							this.llAllSelected 		= false
							this.indeterminateUL 	= false
							this.ulAllSelected 		= false

							this.showExtras = true
							this.showPhone 	= true

							this.trucking_company_id=this.trucking_company_iidd
						}
					} else {
							this.trucking_company_id=this.trucking_company_iidd
					}
				}
			},
			arrayUnique(array) {
    			var a = array.concat();
    			for(var i=0; i<a.length; ++i) {
        			for(var j=i+1; j<a.length; ++j) {
            			if(a[i].id === a[j].id)
                			a.splice(j--, 1);
        			}
    			}
    			return a;
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/users/users.vue